const zh_tw = require("./apexLocales/zh-tw.json")
export default class CONST {
  static activityHourOption = {
    chart: {
      defaultLocale: 'zh-tw',
      height: 300,
      type: "area",
      toolbar: {
        show: true, // show/hide download button on apexcharts
      },
      zoom: {
        enabled: false,
      },
      locales: [zh_tw],
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 2,
      curve: "smooth",

    },
    title: {
      text: "人數",
      align: "left",
    },
    subtitle:{
      text: "呈現各個活動當天每小時人數統計",
      align: "center",
      style:{
        fontSize: '14px',
      },
    },
    legend: {
      onItemClick: {
        toggleDataSeries: false
      }
      // tooltipHoverFormatter: function (val, opts) {
      //   return (
      //     val +
      //     " - " +
      //     opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
      //     ""
      //   );
      // },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {

      type: 'category',
      categories: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
      tickPlacement: 'on',
      tooltip:{
        enabled: false,
      },
      labels: {
        formatter: function(val) {
          // 將值四捨五入到最近的整數，確保不會出現小數標籤
          val = Math.round(val);
          return val;
        }
       },
    },
    tooltip: {
      x: {},
      y: {},

    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  static intergateSearchOption = {
      chart: {
        defaultLocale: 'zh-tw',
        type: 'bar',
        stacked: true,
        height: 350,
        toolbar: {
          show: true, // show/hide download button on apexcharts
        },
        zoom: {
          enabled: false, // show/hide zoom button on apexcharts
        },
        locales: [zh_tw],
      },
      colors: ['#00ae9a'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: [],
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        title: {
          text: '人數'
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        x:{
          formatter:undefined
        },
        y: {
          formatter: function (val) {
            return  val + "位"
          }
        }
      }
  } 

}